"use strict";

const scrollBarInteractions = (current, next) => {
	const body = document.querySelector("body");

	let track, thumb, trackPadding, trackCompHeight;

	const scrollHandler = () => {
		const scrollPos = Math.round(scrollY + window.innerHeight) / body.offsetHeight;

		const scrollAmt = scrollPos * trackCompHeight - thumb.clientHeight;

		thumb.style.transform = `translateY(${scrollAmt}px)`;
	};

	if (next) {
		initScrollBar(next);
	}
	if (current) {
		killScrollBar(current);
	}

	/* Hoistable functions */
	function killScrollBar(container) {
		container.querySelector(".my-scroll-bar").remove();
		window.removeEventListener("scroll", scrollHandler);
	}

	function initScrollBar(container) {
		const scrollBar = `
        <div class="my-scroll-bar">
            <div class="thumb"></div>
        </div>`;

		container.insertAdjacentHTML("afterbegin", scrollBar);

		track = container.querySelector(".my-scroll-bar");
		thumb = container.querySelector(".thumb");

		thumb.style.height = `${100 / (container.scrollHeight / window.innerHeight)}%`;

		trackPadding =
			parseFloat(
				window.getComputedStyle(track).getPropertyValue("padding-top").split("px")[0]
			) +
			parseFloat(
				window.getComputedStyle(track).getPropertyValue("padding-bottom").split("px")[0]
			);
		trackCompHeight = track.clientHeight - trackPadding;

		window.addEventListener("scroll", scrollHandler);
	}
};

export default scrollBarInteractions;
